const KEY_PREFIX = "prntyr:corporateActiveFacility:";

export function getCorporateActiveFacilityKey(userId) {
  return `${KEY_PREFIX}${userId}`;
}

export function readActiveCorporateFacility(userId) {
  if (typeof window === "undefined" || !userId) return null;
  try {
    const raw = localStorage.getItem(getCorporateActiveFacilityKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.facilityId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeActiveCorporateFacility(userId, facility) {
  if (typeof window === "undefined" || !userId || !facility?.facilityId) return;
  const payload = {
    facilityId: facility.facilityId,
    facilityName: facility.facilityName ?? null,
    timezone: facility.timezone ?? null,
    corporateId: facility.corporateId ?? null,
  };
  localStorage.setItem(getCorporateActiveFacilityKey(userId), JSON.stringify(payload));
}

export function clearActiveCorporateFacility(userId) {
  if (typeof window === "undefined" || !userId) return;
  localStorage.removeItem(getCorporateActiveFacilityKey(userId));
}

/** Clear all corporate active-facility keys (e.g. speak2 logout clears all except wasSpeak2User). */
export function clearAllCorporateActiveFacilityKeys() {
  if (typeof window === "undefined") return;
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(KEY_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((k) => localStorage.removeItem(k));
}

/**
 * Detect corporate user from speak2 profile Content.
 */
export function isCorporateProfile(content) {
  if (!content?.CorporateId) return false;
  if (content.IsCorporateUser === true) return true;
  const roles = content.Roles ?? [];
  const activeRole = roles.find((r) => Number(r?.IsActive) === 1) ?? roles[0];
  return activeRole?.Name === "Corporate Admin";
}

/** Stable color for facility swatch from facility id. */
const SWATCH_COLORS = [
  "#c45c5c",
  "#5a9e5a",
  "#7b68ee",
  "#c9a227",
  "#199287",
  "#d4739a",
  "#4a90a4",
  "#98d8c8",
];

export function facilitySwatchColor(facilityId) {
  if (!facilityId) return SWATCH_COLORS[0];
  let hash = 0;
  const str = String(facilityId);
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return SWATCH_COLORS[Math.abs(hash) % SWATCH_COLORS.length];
}
